
import { CharacterFeatureSource } from "@dndModels/character_feature_source/CharacterFeatureSource";
import { 
  CharacterFeatureBase,
  Condition,
} from "@dndModels";

export class CharacterCondition extends CharacterFeatureSource {
  source: Condition | null = null;
  level = 0;
  condition_source_true_id = "";
  condition_source_cf_id = "";
  condition_source_cfb_id = "";

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      this.condition_source_true_id = obj.condition_source_true_id ? obj.condition_source_true_id : "";
      if (this.char_feature_bases.length === 0 && obj.features && obj.features.length > 0) {
        obj.features.forEach((o: any) => {
          const fb = new CharacterFeatureBase(o);
          fb.source_id = this.source_id;
          fb.source_type = "Condition";
          fb.source_name = this.name;
          // fb.root_id = this.source_id;
          // fb.root_type = "Condition";
          // fb.root_name = this.name;
          fb.ancestries = [...this.ancestries.map(o => { return {...o}; })];
          this.char_feature_bases.push(fb);
        });
      }
      this.level = obj.level ? obj.level : 0;
    }
  }

  toDBObj(): any {
    const feature_source_obj = super.toDBObj();
    return {
      ...feature_source_obj,
      condition_source_true_id: this.condition_source_true_id,
      condition_source_cf_id: this.condition_source_cf_id,
      condition_source_cfb_id: this.condition_source_cfb_id,
    };
  }

  clone(drop_ids = false): CharacterCondition {
    const clone = new CharacterCondition();
    clone.copy(this, drop_ids);
    return clone;
  }

  copy(copyMe: CharacterCondition, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.source = copyMe.source;
    this.level = copyMe.level;
    this.condition_source_true_id = copyMe.condition_source_true_id;
    this.condition_source_cf_id = copyMe.condition_source_cf_id;
    this.condition_source_cfb_id = copyMe.condition_source_cfb_id;
  }
}
